import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
const testimonials = [{
  quote: 'Después de 3 años de terapia, este protocolo hizo en semanas lo que no lograron los psicólogos. Localicé el trauma en mi cuerpo y sentí cómo se disolvía.',
  name: 'Marcela V.',
  age: 42,
  location: 'Colombia',
  initials: 'MV'
}, {
  quote: 'Siempre creí que la física cuántica era teoría vacía. Cuando apliqué la Técnica de la Doble Rendija a mi divorcio, algo se rompió en mí — de la mejor manera.',
  name: 'Roberto A.',
  age: 51,
  location: 'México',
  initials: 'RA'
}, {
  quote: 'La sección del Punto Cero cambió mi forma de levantarme cada mañana. Ya no cargo con el peso del pasado desde el primer segundo del día.',
  name: 'Ana S.',
  age: 38,
  location: 'Argentina',
  initials: 'AS'
}, {
  quote: "Compré por curiosidad y terminé llorando de alivio. Por fin alguien que no me dice 'piensa positivo' sino que explica POR QUÉ no funcionaba antes.",
  name: 'Carlos M.',
  age: 47,
  location: 'España',
  initials: 'CM'
}, {
  quote: 'Apliqué el Protocolo Estado Cero durante 7 días y mi ansiedad bajó notablemente. Es práctico, profundo y diferente a todo lo que había leído.',
  name: 'Luis H.',
  age: 44,
  location: 'Chile',
  initials: 'LH'
}];
// Duplicate for seamless infinite scroll (5 + 5 = 10)
const carouselItems = [...testimonials, ...testimonials];
export function TestimonialCarousel() {
  const revealRef = useScrollReveal();
  return <section className="bg-brand-dark bg-grain py-[60px] md:py-[100px] overflow-hidden" data-id="element-204">
      <div ref={revealRef} className="reveal relative z-10" data-id="element-205">
        <div className="text-center mb-12 px-5" data-id="element-206">
          <div className="text-brand-gold text-[11px] tracking-[0.15em] uppercase mb-4" data-id="element-207">
            LO QUE DICEN QUIENES YA RENACIERON
          </div>
          <h2 className="font-display italic text-[clamp(36px,5vw,48px)] text-brand-cream leading-tight max-w-2xl mx-auto" data-id="element-208">
            No nos creas a nosotros.
            <br data-id="element-209" />
            Escúchalos a ellos.
          </h2>
        </div>

        <div className="w-full relative" data-id="element-210">
          <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-brand-dark to-transparent z-10 pointer-events-none" data-id="element-211" />
          <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-brand-dark to-transparent z-10 pointer-events-none" data-id="element-212" />

          <div className="flex gap-5 w-fit animate-scroll-left hover:[animation-play-state:paused] px-5" data-id="element-213">
            {carouselItems.map((item, i) => <div key={i} className="w-[300px] shrink-0 bg-white/[0.04] border border-brand-gold/20 rounded-[16px] p-[28px] transition-all duration-300 hover:-translate-y-[4px] hover:border-brand-gold/40" data-id="element-214">
                <div className="text-brand-gold text-[14px] tracking-[3px] mb-4" data-id="element-215">
                  ★★★★★
                </div>
                <p className="font-display italic font-light text-[18px] text-brand-cream/90 leading-[1.6] mb-6" data-id="element-216">
                  "{item.quote}"
                </p>
                <div className="flex items-center gap-[12px]" data-id="element-217">
                  <div className="w-[40px] h-[40px] rounded-full bg-brand-sage flex items-center justify-center font-body text-[13px] font-medium text-white" data-id="element-218">
                    {item.initials}
                  </div>
                  <div data-id="element-219">
                    <div className="font-body text-[14px] font-medium text-brand-cream/90" data-id="element-220">
                      {item.name}
                    </div>
                    <div className="font-body text-[12px] text-brand-cream/50" data-id="element-221">
                      {item.age} &middot; {item.location}
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}